import React, { useEffect, useState } from 'react';
import { requester } from 'App';
import styles from './StoreSettlement.module.css';

const StoreSettlementAmount = (props) => {
    const { storeId } = props;
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.toLocaleString('ko-KR', { month: 'long' });
    const [totalAmount, setTotalAmount] = useState({});
    const [isMounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            let storeData = { id: storeId };
            requester.getVendorStoreSettlementFee(storeData, (result) => {
                setTotalAmount(result.data);
            });
        }
    }, [isMounted, storeId]);

    return (
        <div className={styles.card}>
            <div className={styles.sectionHeader}>
                <div>
                    <div className={styles.sectionTitle}>스토어 매출액</div>
                    <div className={styles.sectionSubtitle}>
                        ({currentYear}년 {currentMonth} 기준)
                    </div>
                </div>
            </div>

            <div className={styles.amountGrid}>
                <div className={styles.amountRow}>
                    <span className={styles.amountLabel}>이달 매출</span>
                    <span className={styles.amountValue}>
                        {totalAmount?.totalPrice?.toLocaleString() || 0}원
                    </span>
                </div>
                <div className={styles.amountRow}>
                    <span className={styles.amountLabel}>물품 대금</span>
                    <span className={styles.amountValue}>
                        - {totalAmount?.totalsupplyPrice?.toLocaleString() || 0}원
                    </span>
                </div>
                <div className={styles.totalRow}>
                    <span className={styles.totalLabel}>이번달 매출 합계</span>
                    <span className={styles.totalValue}>
                        {(totalAmount?.totalPrice - totalAmount?.totalsupplyPrice).toLocaleString()}원
                    </span>
                </div>
            </div>
        </div>
    );
};

export default StoreSettlementAmount;